<template>
  <div class="works" id="worksgallery">
    <!-- <div id="photoSize" ref="photoSize">Width: {{width}} MaxWidth: {{maxWidth}}</div> -->
    <masonry-wall :items="works" :column-width="200" :gap="25">
      <template v-slot:default="{item}">
        <div class="Item" v-lazy-container="{ selector: 'img' }">
          <div class="Content" v-if="item.showDetails">
              {{item.author}}<br />
              <i>{{item.title}}</i><br />
              {{item.publisher.name}}, {{item.year}}
          </div>
          <img :data-src="item.image" width="200px" height="300px"/>
        </div>
      </template>
    </masonry-wall>
    <ScrollToTopButton />
  </div>
</template>

<script>
import { requestsMixin } from '../mixins/requestsMixin'
import MasonryWall from '@yeger/vue2-masonry-wall'
import ScrollToTopButton from '@/components/ScrollToTopButton.vue'

export default {
  name: 'WorksGallery',
  components: {
    MasonryWall,
    ScrollToTopButton
  },
  data () {
    return {
      category: '',
      page: 1,
      works: [],
      width: 0,
      maxWidth: 0
    }
  },
  created () {
    window.addEventListener('resize', this.showPhotoSize)
  },
  destroyed () {
    window.removeEventListener('resize', this.showPhotoSize)
  },
  mixins: [requestsMixin],
  methods: {
    showWorks (category) {
      console.log('Showing category ' + category)
      this.category = category
      this.page = 1
      this.works = []
      this.downloadWorks()
      // this.showPhotoSize()
    },
    downloadWorks: function () {
      this.fetchWorks(this.category, this.page).then(value => value.forEach(i => this.works.push(i)))
      this.page = this.page + 1
    },
    showPhotoSize () {
      // const w = this.$refs.photoSize.innerHTML = window.innerWidth
      const w = document.getElementsByClassName('masonry-column')[0].children[0].children[0].clientWidth
      this.width = w
      if (w > this.maxWidth) {
        this.maxWidth = w
      }
    }
  },
  mounted () { // Method called the first time the gallery is loaded
    this.showWorks(this.$route.params.category)
  },
  updated () { // Method called when re-entering the gallery component
    console.log('updated')
    const category = this.$route.params.category
    if (category !== undefined && this.category !== category) {
      this.showWorks(category)
    }
  },
  beforeRouteUpdate (to, from, next) { // Method called when the category is changed
    console.log('beforeRouteUpdate')
    this.showWorks(to.params.category)
    next()
  }
}
</script>

<style scoped lang="scss">
  .works {
    padding: 5px;
    margin-top: 30px;
  }

  .Item {
    overflow: hidden;
    border-radius: 5px;
    // width: 100%;
    // margin: 0px;
    margin: 5px;
    padding: 0px;
    filter: drop-shadow(0px 0px 6px #666666);
    background-color: rgba(255, 255, 255, 0.6);
  }
  .Item:hover {
    // filter: drop-shadow(0px 0px 10px #555555);
  }
  .Content {
    padding-top: 3px;
    padding-bottom: 0px;
    padding-right: 5px;
    padding-left: 5px;
    line-height: 140%;
  }
  img {
    object-fit: cover;
    width: 100%;
    height: 100%;
    line-height: 0;
    display: block;
  }
  .masonry-column {
    margin: 10px;
    padding: 10px;
  }
  .masonry-item {
    margin: 10px;
    padding: 10px;
  }

  // @include respond-above(xs) {
  //   .works {
  //     margin-left: 3%;
  //     margin-right: 3%;
  //   }
  // }

  @include respond-above(md) {
    .works {
      padding: 0px;
      margin-left: 15%;
      margin-right: 15%;
    }
    .Item {
    margin: 5px;
    }
  }

  @include respond-below(md) {
    .works {
      // padding: 10px;
      margin-left: 8%;
      margin-right: 8%;
    }
    .Item {
    margin: 5px;
    }
  }

  // @include respond-above(lg) {
  //   .works {
  //     margin-left: 3%;
  //     margin-right: 3%;
  //   }
  // }

</style>
